export default "__VITE_ASSET__BEdh$OJt__"